import React, { useEffect, useState } from "react";
import { Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
// Importar useLocation do react-router-dom para ler o parâmetro de consulta da URL
import { useLocation } from "react-router-dom"; 

export default function ConfirmarExclusao() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codigo = queryParams.get("codigo");

  const [status, setStatus] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [slug, setSlug] = useState("");
  
  useEffect(() => {
    if (!codigo) {
        setStatus("Erro");
        setMensagem("Código de exclusão não encontrado na URL.");
        return;
    }

    const buscarStatus = async () => {
      try {
        // Usando o código obtido da URL
        const res = await axios.get(
          `${API_BASE_URL}/Agendamentos/status-exclusao?codigo=${codigo}`
        );

        if (res.data) {
          const newStatus = res.data.status || "Desconhecido";
          const newSlug = res.data.slug || "";
      
          setStatus(newStatus);
          setSlug(newSlug);
        } else {
          setStatus("Desconhecido");
          setSlug("");
        }
      } catch (err) {
        console.error(err);
        setStatus("Erro");
        setSlug("");
      }
    };

    buscarStatus();
  }, [codigo]); 

  // Confirmar exclusão
  const confirmarExclusao = async () => {
    if (!codigo) return; // Proteção adicional

    setCarregando(true);
    try {
      // Usando o código obtido da URL
      const res = await axios.get(
        `${API_BASE_URL}/Agendamentos/confirmar?codigo=${codigo}`
      );

      const msg = res.data?.mensagem || "Exclusão confirmada com sucesso!";
      const newSlug = res.data?.slug || slug; // se não vier slug, mantém o atual
      setMensagem(msg);
      setStatus("Aprovada");
      setSlug(newSlug);
      
    } catch (error) {
      setMensagem("Erro ao confirmar exclusão.");
      console.error("Erro:", error);
    } finally {
      setCarregando(false);
    }
  };

  const styles = {
    container: {
      backgroundColor: "#808182",
      height: "100vh",
      margin: 0,
      padding: 0,
      display: "flex",
      paddingTop: 50,
      flexDirection: "column",
      alignItems: "center",
    },
    alert: {
      width: "90%",
      maxWidth: "1200px",
      textAlign: "center",
      marginTop: 0,
    },
  };

  const handleVoltar = () => {
    if (slug) {
      window.location.href = `/${slug}`;
    } else {
      window.location.href = "/";
    }
  };

  if (status === "Erro" && mensagem.includes("Código de exclusão não encontrado")) {
    return (
      <div style={{ padding: 50, textAlign: 'center' }}>
        <Alert variant="danger">
          Código de exclusão não encontrado na URL.
        </Alert>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {status === "Aprovada" ? (
        <Alert variant="danger" style={styles.alert}>
          Essa solicitação já foi Aprovada.
        </Alert>
      ) : status === "Pendente" ? (
        <Alert variant="warning" style={styles.alert}>
          Essa solicitação ainda está pendente de confirmação.
        </Alert>
      ) : status === "Erro" ? (
        <Alert variant="danger" style={styles.alert}>
          Erro ao consultar o status da solicitação.
        </Alert>
      ) : (
        <Alert variant="secondary" style={styles.alert}>
          Consultando status...
        </Alert>
      )}

      {mensagem && (
        <Alert variant="info" style={styles.alert}>
          {mensagem}
        </Alert>
      )}

      <div className="mt-3">
  {status === "Pendente" && (
    <>
      <Button
        variant="danger"
        onClick={confirmarExclusao}
        disabled={carregando}
      >
        {carregando ? (
          <>
            <Spinner animation="border" size="sm" /> Confirmando...
          </>
        ) : (
          "Confirmar exclusão"
        )}
      </Button>{" "}
      <Button variant="primary" onClick={handleVoltar}>
        Voltar para o início
      </Button>
    </>
  )}
</div>
    </div>
  );
}